// Keep pages alive between navigations so switching pages does not rebuild them and re-request
// their data. At most MAX_KEPT_ALIVE are held (least recently used is dropped first).
// Pages with live subscriptions/global listeners must release them in deactivated() and
// re-attach in activated() — sale.vue and tableManagement.js do. Others (kitchen, printers,
// waste, ...) are deliberately NOT in this list.
//
// A kept-alive page refreshes itself on re-entry only when its data may be stale:
//   - some write (POST/PUT/PATCH/DELETE) succeeded after the page was left, or
//   - it was left for more than STALE_MS (other devices may have changed the data).
import { getLastMutationAt } from "@/utils/fetchCache";

export const KEEP_ALIVE_PATHS = [
  "/sale",
  "/table",
  "/products",
  "/history-sale",
  "/manage-customers",
  "/manage-category",
  "/manage-suppliers",
  "/manage-product-unit",
  "/manage-stock",
  "/manage-purchase",
  "/manage-users",
  "/manage-branches",
  "/manage-product-options",
  "/manage-ingredients",
  "/expense",
  "/expense-category",
  "/trash-products",
  "/overdue",
  "/overview",
  "/zones",
  "/report-purchase",
  "/report-category",
  "/report-unit",
  "/report-suppliers",
  "/report-branches",
  "/report-customers",
  "/report-users",
  "/report-bill",
  "/report-stock",
];

export const MAX_KEPT_ALIVE = 3;
const STALE_MS = 2 * 60 * 1000;

// vue-router marks the component it renders with data.routerView
const isRoutePage = (vm) =>
  !!(vm.$vnode && vm.$vnode.data && vm.$vnode.data.routerView);

// Registered globally (main.js). activated/deactivated only fire for kept-alive components.
// A page may define `onReactivate()`; otherwise fetchSummary/fetchItem are re-run if present.
export const keepAliveRefreshMixin = {
  deactivated() {
    if (isRoutePage(this)) this.$_leftAt = Date.now();
  },
  activated() {
    if (!isRoutePage(this) || !this.$_leftAt) return; // first activation: created() already loaded
    const leftAt = this.$_leftAt;
    this.$_leftAt = 0;
    const stale =
      getLastMutationAt() > leftAt || Date.now() - leftAt > STALE_MS;
    if (!stale) return;
    if (typeof this.onReactivate === "function") {
      this.onReactivate();
      return;
    }
    ["fetchSummary", "fetchItem"].forEach((fn) => {
      if (typeof this[fn] === "function") this[fn]();
    });
  },
};
